module.exports = __webpack_public_path__ + "media/errors/404-scholarships-b2fb46d0.png";